if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				const purchaseOptions = this.querySelectorAll('[name="purchase_option"]')
				purchaseOptions.forEach(option => option?.addEventListener("change", this.onChangeHandler.bind(this)));
				// Added this to ensure that the selling plan field is disabled when the onetime option is selected and to correctly add the product without the subscription to the cart
				const sellingPlanField = this.querySelector('[name="selling_plan"]');
				if (sellingPlanField) {
					sellingPlanField.disabled = this.querySelector('[name="purchase_option"][value="onetime"]').checked;
				}
				this.cart = document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');

				if (this.cart) this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = true
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(".loading-overlay__spinner")?.classList?.remove("hidden");

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.section)
					);
					formData.append("sections_url", window.location.pathname);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.errors || response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
								cartData: response,
							});
						this.error = false;

						this.cart.renderContents(response);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading-overlay__spinner")?.classList?.add("hidden");
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			onChangeHandler(event) {
				event.preventDefault();
				this.querySelector('[name="selling_plan"]').disabled = event.target.value !== "subscription";
				const atcOption = this.querySelector('.js-atc-option');
				const atcPrice = this.querySelector('.js-atc-price');
				const smallAtcPrice = document.querySelector('.pdp-small-atc-btn .js-atc-price');
				const stickyAtcPrice = document.querySelector('.sticky-atc .js-atc-price');
				const withoutSubscriptionsPrice = this.querySelector('.without-subscriptions .atc-price-single').textContent;
				const withSubscriptionsPrice = this.querySelector('.with-subscriptions .js-atc-price-sub').textContent;
				if (atcOption && atcOption.checked) {
					atcPrice.textContent = withoutSubscriptionsPrice;
					stickyAtcPrice.textContent = withoutSubscriptionsPrice;
					smallAtcPrice.textContent = withoutSubscriptionsPrice;
				} else {
					atcPrice.textContent = withSubscriptionsPrice;
					stickyAtcPrice.textContent = withSubscriptionsPrice;
					smallAtcPrice.textContent = withSubscriptionsPrice;
				}
			}
		}
	);
}